import App from './App.svelte';
import './shared_components/Header.svelte';
import Footer from './shared_components/Footer.svelte';
// const header = new Header({
//     target: document.getElementById('header'),
// });
const app = new App({
    target: document.getElementById('root'),
});
const footer = new Footer({
    target: document.getElementById('footer'),
});
export default app;
